import * as bootstrap from "pkg/bootstrap";
window.bootstrap = bootstrap;

import $ from "pkg/jquery";
window.$ = window.jQuery = $;

import "pkg/daterangepicker";
import "pkg/select2";

import Quill from "pkg/quill";
import QuillTheme from "pkg/@quantum/web/src/js/QuillTheme";
Quill.register("themes/quantum", QuillTheme, true);

import TOC from "pkg/@quantum/web/src/js/TOC";
import Breadcrumb from "pkg/@quantum/web/src/js/Breadcrumb";
import Currency from "pkg/@quantum/web/src/js/Currency";
import InputColorHex from "pkg/@quantum/web/src/js/InputColorHex";
import InputNumber from "pkg/@quantum/web/src/js/InputNumber";
import Select2fn from "pkg/@quantum/web/src/js/Select2fn";
window.quantum = {
  Quill,
  QuillTheme,
  TOC,
  Breadcrumb,
  Currency,
  InputColorHex,
  InputNumber,
  Select2fn,
};

const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
const tooltipList = [...tooltipTriggerList].map(
  (tooltipTriggerEl) => new bootstrap.Tooltip(tooltipTriggerEl),
);
